// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  --ion-background-color: var(--planeed-color-white);
  margin: 0;
  border-radius: 0;
  box-shadow: 0 0 0;
}
@media only screen and (min-width: 460px) {
  ion-card {
    margin: 20px 15px;
    border-radius: 10px;
  }
}

ion-card img {
  border-radius: 50%;
  width: 60px;
  height: 60px;
  object-fit: cover;
  margin: 0 15px;
}

ion-item::part(native) {
  padding-left: unset;
}

.suggestion-people {
  background-color: var(--planeed-color-white);
  margin-bottom: 15px;
}

ion-card-content {
  text-align: center;
}

ion-card-content a {
  color: var(--ion-color-secondary);
}

h3 {
  font-size: 15px;
}

.avatar-box {
  height: 100%;
  padding-top: 16px;
}

.teamInvite {
  width: 100%;
  padding-right: 15px;
  display: flex;
  flex-direction: row;
}
.teamInvite .buttons {
  flex-basis: 80px;
  align-self: center;
}
.teamInvite .invite-title {
  flex-basis: 100%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
